<!-- Subscription Billing Detail Modal -->
<div class="modal fade center-modal-specific" bsModal #subscriptionBillingDetailModal="bs-modal"
  [config]="{keyboard: false, backdrop: 'static'}" id="SubBillingDetails" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered billingDetails" style="max-width: 975px;">
    <div class="modal-content position-relative bg-pure-white"
      style="border-radius: 4px; border: 1px solid #e5e7eb; display: flex; flex-direction: column; overflow: visible;">

      <!-- Close button -->
      <button type="button" class="btn p-1 position-absolute" style="top: 16px; right: 16px; z-index: 10; line-height: 1; border-radius: 4px;"
        (click)="closeBeforeActions();">
        <lucide-icon name="x" [size]="16" [strokeWidth]="2" class="no-fill text-gray-400"></lucide-icon>
      </button>

      <form #editBillingDetailsForm="ngForm" name="editBillingDetailsForm" novalidate autocomplete="off"
        style="display: flex; flex: 1; min-height: 0;">
        <div class="d-flex w-100" style="min-height: 0;">

          <!-- Left Panel: Billing Details -->
          <div class="flex-1" style="padding: 32px; border-right: 1px solid #e5e7eb; min-width: 0;">

            <!-- Header -->
            <div class="mb-4" style="padding-right: 32px;">
              <img src="https://cdn.trovve.com/trovve/login-left-logo.png" alt="Trovve" class="mb-3"
                style="height: 20px; object-fit: contain;">
              <p class="text-gray-900 mb-1 f-size-16" style="font-weight: 500;">Billing details</p>
              <p class="f-size-12 text-gray-400 mb-0">All fields marked <span class="text-danger">*</span> are required</p>
            </div>

            <!-- ── Card Details Section ── -->
            <div class="d-flex align-items-center mb-3" style="gap: 12px; padding-top: 4px;">
              <span class="text-uppercase f-size-11 text-gray-500 text-nowrap flex-shrink-0"
                style="letter-spacing: 0.05em;">Card details</span>
              <div class="flex-1" style="height: 1px; background: #f3f4f6;"></div>
            </div>

            <!-- Name on card -->
            <div class="mb-3">
              <label class="f-size-14 text-gray-700 d-block" style="margin-bottom: 6px;">
                Name on card<span class="text-danger" style="margin-left: 2px;">*</span>
              </label>
              <input type="text" class="form-control" placeholder="As it appears on your card"
                name="fName" #fName="ngModel" [(ngModel)]="localBillingDetail.name"
                inputSpaceValidate [isEditMode]="localBillingDetail.id ? true : false"
                required maxlength="64"
                [ngClass]="{'is-invalid': fName.errors && (fName.dirty || fName.touched)}"
                style="background: #f3f3f5 !important; height: 36px; border-radius: 4px; border: none; font-size: 14px; padding: 0 12px;">
              <div *ngIf="fName.errors && (fName.dirty || fName.touched)" class="invalid-feedback">
                Name is required.
              </div>
            </div>

            <!-- Card number (Stripe Element) -->
            <div class="mb-3">
              <label class="f-size-14 text-gray-700 d-block" style="margin-bottom: 6px;">
                Card number<span class="text-danger" style="margin-left: 2px;">*</span>
              </label>
              <div style="background: #f3f3f5; height: 36px; border-radius: 4px; padding: 0 12px;"
                [ngClass]="{'border border-danger': cardInvalid || cardRequired}">
                <div #cardInfo style="padding-top: 10px;"></div>
              </div>
              <div *ngIf="cardInvalid" class="text-danger f-size-12 mt-1">Invalid card detail entered.</div>
              <div *ngIf="cardRequired" class="text-danger f-size-12 mt-1">Card detail is required.</div>
            </div>

            <!-- ── Billing Address Section ── -->
            <div class="d-flex align-items-center mb-3" style="gap: 12px; padding-top: 4px;">
              <span class="text-uppercase f-size-11 text-gray-500 text-nowrap flex-shrink-0"
                style="letter-spacing: 0.05em;">Billing address</span>
              <div class="flex-1" style="height: 1px; background: #f3f4f6;"></div>
            </div>

            <!-- Street address row -->
            <div class="row mb-3" style="margin-left: -8px; margin-right: -8px;">
              <div class="col-6" style="padding: 0 8px;">
                <label class="f-size-14 text-gray-700 d-block" style="margin-bottom: 6px;">
                  Street address<span class="text-danger" style="margin-left: 2px;">*</span>
                </label>
                <input type="text" class="form-control" placeholder="Street address"
                  name="Address1" #addressLine1="ngModel" [(ngModel)]="localBillingDetail.addressLine1"
                  inputSpaceValidate [isEditMode]="localBillingDetail.id ? true : false"
                  required maxlength="256"
                  [ngClass]="{'is-invalid': addressLine1.errors && (addressLine1.dirty || addressLine1.touched)}"
                  style="background: #f3f3f5 !important; height: 36px; border-radius: 4px; border: none; font-size: 14px; padding: 0 12px;">
                <div *ngIf="addressLine1.errors && (addressLine1.dirty || addressLine1.touched)" class="invalid-feedback">
                  Street address is required.
                </div>
              </div>
              <div class="col-6" style="padding: 0 8px;">
                <label class="f-size-14 text-gray-700 d-block" style="margin-bottom: 6px;">Street address 2</label>
                <input type="text" class="form-control" placeholder="Apt, suite, unit…"
                  name="Address2" [(ngModel)]="localBillingDetail.addressLine2" maxlength="256"
                  style="background: #f3f3f5 !important; height: 36px; border-radius: 4px; border: none; font-size: 14px; padding: 0 12px;">
              </div>
            </div>

            <!-- City + Country row -->
            <div class="row mb-3" style="margin-left: -8px; margin-right: -8px;">
              <div class="col-6" style="padding: 0 8px;">
                <label class="f-size-14 text-gray-700 d-block" style="margin-bottom: 6px;">
                  City<span class="text-danger" style="margin-left: 2px;">*</span>
                </label>
                <input type="text" class="form-control" placeholder="City"
                  name="city" #city="ngModel" [(ngModel)]="localBillingDetail.city"
                  inputSpaceValidate [isEditMode]="localBillingDetail.id ? true : false"
                  required maxlength="256"
                  [ngClass]="{'is-invalid': city.errors && (city.dirty || city.touched)}"
                  style="background: #f3f3f5 !important; height: 36px; border-radius: 4px; border: none; font-size: 14px; padding: 0 12px;">
                <div *ngIf="city.errors && (city.dirty || city.touched)" class="invalid-feedback">
                  City is required.
                </div>
              </div>
              <div class="col-6" style="padding: 0 8px;">
                <label class="f-size-14 text-gray-700 d-block" style="margin-bottom: 6px;">
                  Country<span class="text-danger" style="margin-left: 2px;">*</span>
                </label>
                <div class="dropdown special-drop">
                  <button class="dropdown-toggle text-decoration-none form-control f-size-14 bg-input-background"
                    type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    (click)="onCountryDropdownToggle()"
                    style="height: 36px; border-radius: 4px; font-size: 14px; padding: 0 12px;">
                    <span class="d-flex f-size-14" [style.color]="selectedCountryName ? '#111827' : '#9ca3af'">
                      {{ selectedCountryName || 'Country' }}
                    </span>
                  </button>
                  <div class="dropdown-menu" style="z-index: 1060;">
                    <input type="text" class="form-control mb-1 border-0" placeholder="Search country..."
                      [(ngModel)]="countrySearchText" [ngModelOptions]="{standalone: true}"
                      (click)="$event.stopPropagation()" style="border-bottom: 1px solid #DEDEDE !important;border-radius: 0 !important;">
                    <div class="items">
                      <a class="dropdown-item" href="javascript:;" *ngFor="let c of filteredCountries"
                        [ngClass]="{selected: countryId && countryId[0] === c.id.toString()}"
                        (click)="selectCountry(c)">
                        <span class="text-none">{{c.name}}</span>
                      </a>
                      <div *ngIf="filteredCountries.length === 0" class="px-3 py-2 f-size-12 text-gray-400">
                        No results found
                      </div>
                    </div>
                  </div>
                </div>
                <input type="hidden" name="countryName" #country="ngModel"
                  [(ngModel)]="selectedCountryName" required>
                <div *ngIf="country.errors && (country.dirty || country.touched)"
                  class="text-danger f-size-12 mt-1">
                  Country is required.
                </div>
              </div>
            </div>

            <!-- State + Zip row -->
            <div class="row mb-3" style="margin-left: -8px; margin-right: -8px;">
              <div class="col-6" style="padding: 0 8px;">
                <label class="f-size-14 text-gray-700 d-block" style="margin-bottom: 6px;">
                  State<span class="text-danger" style="margin-left: 2px;">*</span>
                </label>
                <input type="text" class="form-control" placeholder="State"
                  name="State" #state="ngModel" [(ngModel)]="localBillingDetail.state"
                  inputSpaceValidate [isEditMode]="localBillingDetail.id ? true : false"
                  required maxlength="256"
                  [ngClass]="{'is-invalid': state.errors && (state.dirty || state.touched)}"
                  style="background: #f3f3f5 !important; height: 36px; border-radius: 4px; border: none; font-size: 14px; padding: 0 12px;">
                <div *ngIf="state.errors && (state.dirty || state.touched)" class="invalid-feedback">
                  State is required.
                </div>
              </div>
              <div class="col-6" style="padding: 0 8px;">
                <label class="f-size-14 text-gray-700 d-block" style="margin-bottom: 6px;">
                  Zip / postal code<span class="text-danger" style="margin-left: 2px;">*</span>
                </label>
                <input type="text" class="form-control" placeholder="Zip / postal"
                  name="postalCode" #postalCode="ngModel" [(ngModel)]="localBillingDetail.postalCode"
                  inputSpaceValidate [isEditMode]="localBillingDetail.id ? true : false"
                  required maxlength="16"
                  [ngClass]="{'is-invalid': postalCode.errors && (postalCode.dirty || postalCode.touched)}"
                  style="background: #f3f3f5 !important; height: 36px; border-radius: 4px; border: none; font-size: 14px; padding: 0 12px;">
                <div *ngIf="postalCode.errors && (postalCode.dirty || postalCode.touched)" class="invalid-feedback">
                  Zip / Postal is required.
                </div>
              </div>
            </div>

            <!-- Security note -->
            <div class="d-flex align-items-center" style="margin-top: 28px; gap: 6px;">
              <lucide-icon name="lock" [size]="12" [strokeWidth]="2" class="no-fill text-gray-400 flex-shrink-0"></lucide-icon>
              <span class="f-size-11 text-gray-400">Payments encrypted and processed securely via Stripe. We never store your card details.</span>
            </div>
          </div>

          <!-- Right Panel: Order Summary -->
          <div class="d-flex flex-column flex-shrink-0" style="width: 332px; padding: 32px; background: #f9fafb;height: -webkit-fill-available;">

            <p class="w-100 text-gray-900" style="font-size: 15px; font-weight: 500; margin-bottom: 20px;">Order summary</p>

            <!-- Plan details -->
            <div class="w-100 f-size-14" style="margin-bottom: 20px;">
              <div class="d-flex justify-content-between" style="margin-bottom: 12px;">
                <span class="text-gray-500">Plan</span>
                <span class="text-gray-900">{{planName}}</span>
              </div>
              <div class="d-flex justify-content-between" style="margin-bottom: 12px;">
                <span class="text-gray-500">Per user</span>
                <span class="text-gray-900">{{amount | currency}}/{{subUnit === 'year' ? 'yr' : subUnit === 'qtr' ? 'qtr' : 'mo'}}</span>
              </div>
              <div class="d-flex justify-content-between">
                <span class="text-gray-500">Billing</span>
                <span class="text-gray-900">{{subUnit === 'year' ? 'Annual' : subUnit === 'qtr' ? 'Quarterly' : 'Monthly'}}</span>
              </div>
            </div>

            <!-- Users -->
            <div class="w-100" style="padding-top: 16px; margin-bottom: 16px; border-top: 1px solid #e5e7eb;">
              <div class="d-flex align-items-center justify-content-between" style="margin-bottom: 6px;">
                <span class="f-size-14 text-gray-500">Users</span>
                <input type="number" [min]="minUsers" [max]="maxUsers" name="Quantity" #qty="ngModel"
                  required digitOnly [(ngModel)]="noOfUsers"
                  class="form-control text-center"
                  style="width: 64px; height: 32px; font-size: 14px; border: 2px solid #d1d5db; border-radius: 4px; padding: 0;">
              </div>
              <div *ngIf="noOfUsers < minUsers"
                class="text-danger f-size-11" style="margin-top: 4px;">
                A minimum of {{minUsers}} users is required for the {{planName}} Plan. Please adjust your quantity to proceed.
              </div>
            </div>

            <!-- Discount code -->
            <div class="w-100" style="margin-bottom: 20px;">
              <!-- Add discount link -->
              <button *ngIf="!showCouponInput && !couponDetails" type="button"
                class="btn p-0 d-flex align-items-center f-size-12" style="color: #2563eb; gap: 6px;"
                (click)="showCouponInput = true">
                <lucide-icon name="tag" [size]="12" [strokeWidth]="2" class="no-fill"></lucide-icon>
                Add discount code
              </button>
              <!-- Coupon input -->
              <div *ngIf="showCouponInput && !couponDetails" class="d-flex" style="gap: 8px;">
                <input type="text" class="form-control f-size-12" placeholder="Add discount code"
                  name="discountCode" [(ngModel)]="discountCode" (input)="onCodeInput($event)"
                  style="height: 32px; font-size: 12px;">
                <button type="button" class="btn btn-sm btn-primary flex-shrink-0"
                  *ngIf="discountCode !== ''" (click)="validateCoupon()"
                  style="height: 32px; font-size: 12px;">Apply</button>
              </div>
              <div *ngIf="discountCodeError" class="text-danger f-size-11 mt-1">This code is invalid.</div>
              <!-- Applied coupon - green box -->
              <div *ngIf="couponDetails" class="rounded" style="background: #f0fdf4; border: 1px solid #bbf7d0; padding: 10px 12px;">
                <div class="d-flex align-items-center justify-content-between" style="margin-bottom: 4px;">
                  <div class="d-flex align-items-center" style="gap: 8px;">
                    <div class="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                      style="width: 16px; height: 16px; background: #16a34a;">
                      <lucide-icon name="check" [size]="10" [strokeWidth]="3" class="no-fill text-white"></lucide-icon>
                    </div>
                    <span class="f-size-12" style="color: #166534;">Code applied</span>
                  </div>
                  <button type="button" class="btn p-0" style="line-height: 1; color: #16a34a;"
                    title="Remove code" (click)="clearCoupon()">
                    <lucide-icon name="x" [size]="14" [strokeWidth]="2" class="no-fill"></lucide-icon>
                  </button>
                </div>
                <div class="d-flex align-items-center justify-content-between" style="padding-left: 24px;">
                  <span class="f-size-12 text-uppercase" style="color: #15803d; letter-spacing: 0.05em;">{{couponDetails.name}}</span>
                  <span class="f-size-12" style="color: #15803d;">{{couponDetails?.percent_off}}% off</span>
                </div>
              </div>
            </div>

            <!-- Totals -->
            <div class="w-100 f-size-14" style="padding-top: 16px; margin-bottom: 20px; border-top: 1px solid #e5e7eb;">
              <div class="d-flex justify-content-between" style="margin-bottom: 10px;">
                <span class="text-gray-500">Subtotal</span>
                <span class="text-gray-900">{{amount * noOfUsers | currency}}</span>
              </div>
              <div class="d-flex justify-content-between" style="margin-bottom: 10px;">
                <span class="text-gray-500">Discount</span>
                <span class="text-gray-900">&minus;{{getDiscountAmount() | currency}}</span>
              </div>
              <div class="d-flex justify-content-between" style="padding-top: 10px; border-top: 1px solid #e5e7eb;">
                <span class="text-gray-900 font-weight-medium">Total</span>
                <span class="text-gray-900 font-weight-medium">{{getTotal() | currency}}</span>
              </div>
            </div>

            <!-- Subscribe button -->
            <button type="button"
              class="btn w-100 f-size-14 text-white d-flex align-items-center justify-content-center"
              style="background: #111827; border-radius: 4px; padding: 10px 0; gap: 8px;"
              [disabled]="busyLoad || isSavingSubscription || noOfUsers < minUsers || editBillingDetailsForm.invalid || cardInvalid || cardRequired"
              (click)="purchaseNow()">
              <lucide-icon name="shield-check" [size]="14" [strokeWidth]="2" class="no-fill"></lucide-icon>
              Subscribe now
            </button>

            <!-- Terms -->
            <p class="w-100 f-size-10 text-gray-400 text-center" style="margin-top: 12px; line-height: 1.5;">
              By subscribing, you agree to our subscriber terms.
              Subscription renews automatically. Cancel before your
              next billing date to avoid charges.
            </p>
          </div>

        </div>
      </form>

      <vf-spinner *ngIf="busyLoad"></vf-spinner>
    </div>
  </div>
</div>
